// Actions Type
export const SET_DASHBOARD_DATA = 'set_dashboard_data'

// Action Types
export type DashboardDataAction = {
    type: typeof SET_DASHBOARD_DATA;
    payload: any | null
}

export type DashboardActionType = 
    DashboardDataAction